// French cities + departments helper data

export const FEATURED_CITIES = [
  { name: "Paris", slug: "paris", department: "75" },
  { name: "Lyon", slug: "lyon", department: "69" },
  { name: "Marseille", slug: "marseille", department: "13" },
  { name: "Toulouse", slug: "toulouse", department: "31" },
  { name: "Nice", slug: "nice", department: "06" },
  { name: "Nantes", slug: "nantes", department: "44" },
  { name: "Bordeaux", slug: "bordeaux", department: "33" },
  { name: "Lille", slug: "lille", department: "59" },
  { name: "Rennes", slug: "rennes", department: "35" },
  { name: "Strasbourg", slug: "strasbourg", department: "67" },
  { name: "Montpellier", slug: "montpellier", department: "34" },
  { name: "Nancy", slug: "nancy", department: "54" },
];

export const VOLUMES = [
  "Studio (5-10m³)",
  "T1/T2 (10-25m³)",
  "T3 (25-35m³)",
  "T4 (35-50m³)",
  "T5+ / Maison (50m³+)",
];

export const LEAD_STATUSES = [
  { key: "nouveau",    label: "Nouveau",    color: "#1D3557" },
  { key: "envoye",     label: "Envoyé",     color: "#D4A373" },
  { key: "relance_1",  label: "Relance 1",  color: "#F2C57C" },
  { key: "relance_2",  label: "Relance 2",  color: "#F0A868" },
  { key: "relance_3",  label: "Relance 3",  color: "#E07A5F" },
  { key: "interesse",  label: "Intéressé",  color: "#81B29A" },
  { key: "refuse",     label: "Refusé",     color: "#C44536" },
  { key: "accepte",    label: "Accepté",    color: "#1C1C1C" },
];

export const statusLabel = (key) => {
  const s = LEAD_STATUSES.find((x) => x.key === key);
  return s ? s.label : key;
};
